var map = {
	"./上半年/习近平法治思想.json": "34b5",
	"./上半年/最新《行政处罚法》题库.json": "2c0b",
	"./上半年/行政处罚之审查决定与执行.json": "3777",
	"./上半年/行政处罚之立案与调查取证.json": "3b4d",
	"./下半年/习近平法治思想（1）（新）.json": "0c7c",
	"./下半年/最新《行政处罚法》题库.json": "d404",
	"./下半年/行政处罚之审查决定与执行.json": "a451",
	"./下半年/行政处罚之立案与调查取证.json": "ab2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0bb";